<template>
  <v-app>
    <template v-if="!profileLoaded && !apiDown">
      <asc-app-loading-template></asc-app-loading-template>
    </template>
    <template v-if="profileLoaded || apiDown">
      <asc-page-error-template
        v-if="apiDown || showTermsAndConditions"
        :error-type="apiDown ? 500 : null"
        :loading="buttonLoading"
        :terms-and-conditions="showTermsAndConditions"
        @userSubmit="handleSubmit"
      />
      <asc-page-container
        v-if="!showTermsAndConditions && !apiDown"
        :api-page-failure="getApiErrors"
        :footer-text="getFooterText"
        :current-year="getCurrentYear"
      >
        <router-view :key="$route.fullPath" />
        <asc-gdpr-notification
          v-if="!cookieAlertSeen"
          :on-close="handleGDPRCloseClick"
        ></asc-gdpr-notification>
      </asc-page-container>
      <div id="ZN_1LI3PTMu2PGoZJb">
        <!--DO NOT REMOVE-CONTENTS PLACED HERE-->
      </div>
    </template>
  </v-app>
</template>

<script>
import AscPageContainer from '@/components/features/page/containers/AscPageContainer'
import {
  AscAppLoadingTemplate,
  AscPageErrorTemplate,
} from '@/components/templates'
import AscGdprNotification from '@/components/molecules/AscGdprNotification'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import {
  ATTACHMENT_CONSTS as AC,
  MAINTENANCE_ISSUES_CONSTS as MIC,
  USER_CONSTS as UC,
} from '@/stores/consts'
import { DEFAULT_ECCN_TEXT } from '@/utilities/appConsts'

export default {
  components: {
    AscPageContainer,
    AscAppLoadingTemplate,
    AscPageErrorTemplate,
    AscGdprNotification,
  },

  data() {
    return {
      isFull: false,
      buttonLoading: false,
    }
  },

  computed: {
    ...mapGetters(UC.NAMESPACE, ['profileLoaded']),
    ...mapState(UC.NAMESPACE, ['termsAccepted']),
    ...mapState(['apiDown', 'cookieAlertSeen', 'ipValid', 'ipValidated']),
    ...mapState(['currentEccn']),
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(AC.NAMESPACE, ['attachmentErrors']),
    ...mapState(MIC.NAMESPACE, ['apiErrors']),

    getFooterText() {
      let text = DEFAULT_ECCN_TEXT
      if (
        this.currentEccn &&
        this.currentEccn !== '' &&
        this.$route.meta &&
        this.$route.meta.requiresEccn
      ) {
        text =
          'Collins Aerospace Proprietary Information. US Export Classification: EAR ' +
          this.currentEccn
      }
      return text
    },
    getCurrentYear() {
      return new Date().getFullYear()
    },

    showTermsAndConditions() {
      return !this.termsAccepted
    },

    getApiErrors() {
      return this.attachmentErrors.length || this.apiErrors.length
        ? this.apiErrors.concat(this.attachmentErrors)
        : this.apiPageFailure
    },
  },

  async mounted() {
    const isAuth = await this.$auth.isAuthenticated()
    if (!isAuth) {
      await this.$auth.signInWithRedirect()
    }
  },
  methods: {
    ...mapMutations(['updateCookieAlertSeen']),
    ...mapActions(UC.NAMESPACE, [UC.SET_TANDC_DATA, UC.GET_TANDC_DATA]),

    async handleSubmit() {
      this.buttonLoading = true
      await this[UC.SET_TANDC_DATA]()
      await this[UC.GET_TANDC_DATA]()
      this.buttonLoading = false
    },

    handleGDPRCloseClick() {
      this.updateCookieAlertSeen(true)
    },

    async signIn() {
      await this.$auth.signInWithRedirect()
    },

    async signOut() {
      await this.$auth.signOut()
    },
  },
}
</script>
